import React, { useState, useEffect } from 'react';
import { DealerGroup } from '../../types/Group';

interface GroupFormProps {
  group: DealerGroup | null;
  onSubmit: (group: DealerGroup) => void;
  onCancel: () => void;
}

const GroupForm: React.FC<GroupFormProps> = ({ group, onSubmit, onCancel }) => {
  const [dealerCode, setDealerCode] = useState<string>('');
  const [groupName, setGroupName] = useState<string>('');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (group) {
      setDealerCode(group.dealerCode || '');
      setGroupName(group.groupName);
    } else {
      setDealerCode('');
      setGroupName('');
    }
  }, [group]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Trim values for validation
    const trimmedDealerCode = dealerCode.trim();
    const trimmedGroupName = groupName.trim();
    
    // Validate - only group name is required now
    if (!trimmedGroupName) {
      setError('Group name is required');
      return;
    }
    
    // Clear any previous errors
    setError(null);
    
    // Submit the form
    onSubmit({
      ...(group ? { id: group.id } : {}),
      ...(trimmedDealerCode ? { dealerCode: trimmedDealerCode } : {}),
      groupName: trimmedGroupName
    });
  };

  return (
    <div className="form-container">
      <h2>{group ? 'Edit Dealer Group' : 'Add New Dealer Group'}</h2>
      
      {error && <div className="error-message">{error}</div>}
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="dealerCode">Dealer Code (Optional)</label>
          <input
            type="text"
            id="dealerCode"
            value={dealerCode}
            onChange={(e) => setDealerCode(e.target.value)}
            placeholder="Enter dealer code (optional)"
            autoFocus
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="groupName">Group Name</label>
          <input
            type="text"
            id="groupName"
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
            placeholder="Enter group name"
          />
        </div>
        
        <div className="form-actions">
          <button 
            type="button" 
            className="secondary-button" 
            onClick={onCancel}
          >
            Cancel
          </button>
          <button 
            type="submit" 
            className="primary-button"
          >
            {group ? 'Update' : 'Create'} Group
          </button>
        </div>
      </form>
    </div>
  );
};

export default GroupForm; 